import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconUserSvg } from './IconUserSvg';

export type IconUserProps = UseIconProps;

export function IconUser(props: IconUserProps) {
  const iconProps = useIcon(props);

  return <Box tagName={IconUserSvg} {...iconProps} />;
}
